import { useCognitoUserContext } from 'domains/auth/AWSCognitoWrapper/context';
import { AuthedGate } from 'domains/auth/AuthedGate';
import { ProfileSelectedGate } from 'domains/auth/ProfileSelectedGate';
import { AuthedLayout, BasicLayout } from '..';

export const AuthedOrBasicLayout = (): JSX.Element => {
  const { isLoggedIn } = useCognitoUserContext();

  if (isLoggedIn) {
    return (
      <AuthedGate>
        <ProfileSelectedGate>
          <AuthedLayout />
        </ProfileSelectedGate>
      </AuthedGate>
    );
  }

  return <BasicLayout showLogin />;
};
